var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRLegal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-legal",
    x: 0.784,
    y: 0.131,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconR-legal1",
    serifid: "iconR-legal",
    d: "M10.027,14.019c0,-0.456 0.039,-0.248 -2.41,-5.138c-0.248,-0.498 -0.732,-0.75 -1.213,-0.75c-0.482,-0 -0.966,0.252 -1.218,0.75c-2.463,4.934 -2.406,4.696 -2.406,5.138c0,1.249 1.621,2.265 3.598,2.265c1.977,-0 3.649,-1.017 3.649,-2.265Zm-3.626,-4.53l2.044,4.077l-4.081,-0l2.037,-4.077Zm12.754,9.124l-5.576,-0l-0.044,-9.963c0.872,-0.277 1.545,-1.067 1.73,-1.978l3.872,-0c0.422,-0 0.736,-0.343 0.736,-0.736c-0,-0.45 -0.312,-0.793 -0.764,-0.793l-4.035,0c-0.367,-0.9 -1.262,-1.458 -2.304,-1.458c-1.041,-0 -1.925,0.558 -2.316,1.458l-4.053,0c-0.422,0 -0.736,0.343 -0.736,0.736c0,0.393 0.312,0.793 0.736,0.793l3.872,-0c0.183,0.911 0.86,1.702 1.732,1.977l0.044,9.964l-5.604,-0c-0.459,-0 -0.74,0.308 -0.74,0.766c-0,0.462 0.279,0.75 0.74,0.75l12.71,0c0.487,0 0.76,-0.241 0.76,-0.75c0,-0.469 -0.279,-0.766 -0.76,-0.766Zm3.625,-4.585c-0,-0.456 0.039,-0.248 -2.41,-5.138c-0.223,-0.498 -0.732,-0.75 -1.214,-0.75c-0.481,-0 -0.966,0.251 -1.217,0.75c-2.437,4.934 -2.381,4.696 -2.381,5.138c0,1.249 1.621,2.265 3.624,2.265c2.003,-0 3.598,-1.017 3.598,-2.265Zm-5.662,-0.453c0,0 1.514,-3.015 2.037,-4.076l2.043,4.076l-4.08,0Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRLegal);
export default __webpack_public_path__ + "static/media/iconR-legal.86041799b5f74f9b88653df213c3f9fb.svg";
export { ForwardRef as ReactComponent };